// Update your types/chat.ts file

export interface ChatMessage {
  id?: string;
  role: 'user' | 'ai' | 'system';
  text: string | null;
  rawText?: string; // Original unformatted text for audio/other purposes
  isFormatted?: boolean; // Whether the text contains HTML formatting
  timestamp: string | number;
  session_id?: string;
  sources?: MessageSource[];
  feedback?: MessageFeedback;
  isStreaming?: boolean;
  isTypingPlaceholder?: boolean;
  isDashboardQuestion?: boolean; // NEW: Flag for dashboard system questions

  // Audio-related properties (if used)
  isAudioEnabled?: boolean;
  isCurrentlyPlaying?: boolean;
  isAudioLoading?: boolean;
  hasCachedAudio?: boolean;
  audioProgress?: number;
  onPlayAudio?: (messageId: string, text: string) => void;
  onStopAudio?: () => void;
}

// If you use MessageSource and MessageFeedback, make sure they're defined too
export interface MessageSource {
  name?: string;
  link?: string;
  content?: string;
  // Legacy properties (optional/deprecated)
  url?: string;
  title?: string;
  type?: string;
}

export interface MessageFeedback {
  // Add your feedback properties here
  rating?: number;
  comment?: string;
}

export interface WebSocketMessage {
  type: 'user' | 'ai' | 'system' | 'ai_chunk' | 'conversation_history' | 'error';
  message?: string;
  session_id?: string;
  id?: string;
  chunk_type?: 'partial' | 'complete';
  messages?: Array<{
    id?: string;
    type: string;
    message: string;
    timestamp?: number;
    sources?: MessageSource[];
    feedback?: MessageFeedback;
  }>;
  error_code?: string;
  timestamp?: number;
  sources?: MessageSource[];
  feedback?: MessageFeedback;
}

export enum ChatSource {
  DEFAULT = 'default',
  MOOD_JOURNAL = 'mood_journal',
  DASHBOARD = 'dashboard',
}
